<template>
  <div>
    <q-form ref="editForm">
      <!-- 일상 순회점검 기본정보 -->
      <c-card title="일상 순회점검 기본정보" class="cardClassDetailForm">
        <template slot="card-button">
          <q-btn-group outline >
            <!-- [S]결재관련 버튼 -->
            <!-- sysApprovalRequestId: 상세조회시 관련 결재요청일련번호 확인 -->
            <!-- popupParam.isApprContent: 결재요청/결재처리 팝업의 component에 해당 페이지 호출시 true -->
            <!-- approvalStatusCd: 결재요청건에 대한 상태코드 -->
            <!-- popupParam.approvalDocType: TODO(결재할문서에서 상세페이지호출시) -->
            <c-appr-btn 
              ref="appr-btn"
              name="daily-circuit-appr-btn"
              :editable="editable"
              :approvalInfo="approvalInfo"
              @beforeApprAction="saveDataAppr"
              @callbackApprAction="approvalCallback"
              @requestAfterAction="getDetail"
            />
            <!-- 삭제 -->
            <c-btn 
              v-show="editable && !disabled && isOld" 
              label="LBLREMOVE" 
              icon="delete_forever" 
              @btnClicked="removeData" />
            <!-- 저장 -->
            <c-btn
              v-show="editable && !disabled && !dailyCircuit.sysApprovalRequestId"
              :url="saveUrl"
              :isSubmit="isSave"
              :param="dailyCircuit"
              :mappingType="mappingType"
              label="LBLSAVE"
              icon="save"
              @beforeAction="saveData"
              @btnCallback="saveCallback" />
          </q-btn-group>
        </template>
        <template slot="card-detail">
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <c-plant
              required
              :disabled="disabled || isOld"
              :editable="editable"
              type="none"
              name="plantCd"
              v-model="dailyCircuit.plantCd"
              @datachange="datachange('A')">
            </c-plant>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <!-- 점검년월 -->
            <c-datepicker
              required
              :disabled="disabled"
              :editable="editable"
              label="LBL0002200"
              type="month"
              name="checkDate"
              v-model="dailyCircuit.checkDate"
              @datachange="datachange('B')">
            </c-datepicker>
          </div>
          <div class="col-xs-12 col-sm-12 col-md-4 col-lg-4 col-xl-4">
            <!-- 점검부서 -->
            <c-dept
              required
              :disabled="disabled || isOld"
              :editable="editable"
              label="LBL0002201"
              name="checkDeptCd"
              v-model="dailyCircuit.checkDeptCd"
              @setDeptName="setDeptName"
              @datachange="datachange('A')">
            </c-dept>
          </div>
        </template>
      </c-card>
      <c-tab
        type="tabcard"
        :tabItems.sync="tabItems"
        :inlineLabel="true"
        v-model="tab"
        :height="tabHeight"
        align="left"
        @tabClick="tabClick"
      >
        <template v-slot:default="tab">
          <component
            :is="tab.component"
            :dailyCircuit="dailyCircuit"
            :grid.sync="grid"
            :isOld="isOld"
            :imprTabInfo.sync="imprTabInfo"
            :contentHeight="contentHeight"
            :disabled="disabled"
            @getDetail="getDetail"
            @setKey="setKey"
            @save="saveData2"
          />
        </template>
      </c-tab>
      <c-dialog :param="popupOptions"></c-dialog>
    </q-form>
  </div>
</template>

<script>
import { uid } from 'quasar';
import selectConfig from '@/js/selectConfig';
import transactionConfig from '@/js/transactionConfig';
export default {
  name: 'daily-circuit-check-detail',
  props: {
    popupParam: {
      type: Object,
      default: () => ({
        dccDailyCircuitCheckId: '',
      }),
    },
    contentHeight: {
      type: [String, Number],
      default: function() {
        return 'auto'
      },
    }
  },
  data() {
    return {
      grid: {
        columns: [],
        height: 'auto',
      },
      dailyCircuit: {
        dccDailyCircuitCheckId: '',  // 열화점검 일련 번호
        plantCd: '',  // 사업장 코드
        checkStatusCd: '',  // 계획수립/점검중/점검완료
        checkDeptCd: '',  // 점검부서
        checkUserId: '',  // 점검자 ID
        checkDate: '',  // 점검월
        checkName: '',  // 점검명
        evaluationCompleteFlag: 'N',  // 결재완료 후 평가완료 처리
        approvalStatusCd: '', // 결재관련 결재상태
        sysApprovalRequestId: '', // 결재관련 결재요청코드
        checkResultList: [], // sheet
        checkImproveList: [], // 개선 list
        checkUserList: [],
      },
      editable: true,
      saveUrl: '',
      deleteUrl: '',
      isSave: false,
      isApproval: false,
      mappingType: 'POST',
      detailUrl: '',
      resultItemUrl: '',
      holidayUrl: '',
      holidayList: [],
      today: '',
      tab: 'dailyCircuitCheckResult',
      tabItems: [
        // 일상 순회점검 결과
        { name: 'dailyCircuitCheckResult', icon: 'list', label: '일상 순회점검 결과', component: () => import(`${'./dailyCircuitCheckResult.vue'}`) },
        // 개선관리
        { name: 'dailyCircuitCheckImpr', icon: 'construction', label: 'LBL0000331', component: () => import(`${'@/pages/common/ibm/imprTab.vue'}`), disabled: true },
      ],
      research: {
        impr: '',
        item: '',
      },
      popupOptions: {
        isFull: true,
        // width: '80%',
        target: null,
        title: '',
        visible: false,
        top: '',
        param: {},
        closeCallback: null,
      },
    };
  },
  beforeCreate() {},
  created() {},
  beforeMount() {
    Object.assign(this.$data, this.$options.data());
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
  },
  computed: {
    tabHeight() {
      return String(this.contentHeight - 156);
    },
    approvalInfo() {
      return {
        sysApprovalRequestId: this.dailyCircuit.sysApprovalRequestId, // 결재요청번호
        /**
         * 결재상태코드
         * ASC0000001	결재중
         * ASC0000002	반려
         * ASC9999999	결재완료
         */
        approvalStatusCd: this.dailyCircuit.approvalStatusCd, 
        apprEditable: this.dailyCircuit.checkStatusCd && this.dailyCircuit.checkStatusCd !== 'MCSC000015', // 결재버튼 활성화 기준
        param: this.dailyCircuit, // 결재 param
        approvalUrl: this.updateUrl, // 결재 url
        isApproval: this.isApproval, // 결재 submit
        approvalTypeCd: 'APTC000023', // 결재유형코드
        approvalParamValue: { // 결재상세화면 파라미터
          dccDailyCircuitCheckId: this.dailyCircuit.dccDailyCircuitCheckId,
          isApprContent: true
        },
        approvalRequestName: '일상 순회점검 [' + this.dailyCircuit.checkName + ']', // 결재요청명 (문서 title)
        approvalConnId: this.popupParam.dccDailyCircuitCheckId, // 결재연결용 업무일련번호 (문서 key)
      }
    },
    isOld() {
      return Boolean(this.popupParam.dccDailyCircuitCheckId);
    },
    disabled() {
      return this.dailyCircuit.checkStatusCd === 'MCSC000015'
        || this.dailyCircuit.approvalStatusCd === 'ASC0000001'
    },
    imprTabInfo() {
      return {
        key: this.popupParam.dccDailyCircuitCheckId, // 
        ibmTaskTypeCd: 'ITT0000210',
        ibmTaskUnderTypeCd: 'ITTU000240',
        requestContents: this.dailyCircuit.checkName,
        disabled: this.disabled,
        isOld: this.isOld,
        gridItem: {
          listUrl: selectConfig.sop.dcc.improve.get.url,
          param: {
            dccDailyCircuitCheckId: this.popupParam.dccDailyCircuitCheckId,
            imprFlag: true,
          },
          title: 'LBL0002209', // 점검항목별 개선목록
          merge: [
            { index: 0, colName: 'dccDailyCircuitCheckResultId' },
          ],
          columns: [
            {
              name: 'checkItemName',
              field: 'checkItemName',
              // 점검항목
              label: 'LBL0002210',
              align: 'left',
              style: 'width:40%',
              sortable: false,
              fix: true,
            },
            {
              name: 'dayStr',
              field: 'dayStr',
              label: '일',
              align: 'center',
              style: 'width:10%',
              sortable: false,
              fix: true,
            },
          ],
          research: this.research,
        },
        gridOther: {
          title: 'LBL0001424', // 항목외 개선 목록
        },
      }
    }
  },
  watch: {
    contentHeight() {
      let height = (this.contentHeight - 240);
      if (height < 400) {
        height = 500;
      }
      this.grid.height = height + 'px'
    },
  },
  methods: {
    init() {
      // role setting
      this.editable = this.$route.meta.editable;
      if (this.popupParam.dccDailyCircuitCheckId) {
        this.$set(this.tabItems[1], 'disabled', false)
      }
      // url setting
      this.detailUrl = selectConfig.sop.dcc.plan.get.url;
      this.updateUrl = transactionConfig.sop.dcc.plan.update.url;
      this.saveUrl = transactionConfig.sop.dcc.plan.insert.url;
      this.deleteUrl = transactionConfig.sop.dcc.plan.delete.url;
      this.resultItemUrl = selectConfig.sop.dcc.result.newItem.url;
      this.holidayUrl = selectConfig.sys.holiday.list.url; // 음력 공휴일구하기
      // code setting
      this.today = this.$comm.getToday();

      // list setting
      this.getDetail()
    },
    getDetail() {
      if (this.popupParam.dccDailyCircuitCheckId) {
        this.$http.url = this.$format(this.detailUrl, this.popupParam.dccDailyCircuitCheckId);
        this.$http.type = 'GET';
        this.$http.request((_result) => {
          this.$_.extend(this.dailyCircuit, _result.data);
          this.setColumns();
        },);
      } else {
        this.datachange('A');
      }
    },
    setKey(data) {
      this.popupParam.dccDailyCircuitCheckId = data
      this.getDetail();
    },
    datachange(type) {
      if (type === 'A' && this.dailyCircuit.plantCd && this.dailyCircuit.checkDeptCd) {
        /**
         * 사업장에 따라 점검항목을 변경
         * 
         * 사업장은 `선택`이 될 수 없게 처리
         */
        this.$http.url = this.resultItemUrl;
        this.$http.type = 'GET';
        this.$http.param = {
          plantCd: this.dailyCircuit.plantCd,
          deptCd: this.dailyCircuit.checkDeptCd,
        };
        this.$http.request((_result) => {
          this.dailyCircuit.checkResultList = _result.data;
          this.$_.forEach(this.dailyCircuit.checkResultList, _item => {
            _item.dccDailyCircuitCheckResultId = uid()
          })
          this.setColumns();
        },);
      } else if (type === 'B' && this.dailyCircuit.checkDate) {
        // this.grid.data = [];
        this.setColumns();
      }
    },
    setColumns() {
      if (!this.dailyCircuit.checkDate) return;
      let _columns = [
        {
          name: 'checkItemName',
          field: 'checkItemName',
          // 점검항목
          label: 'LBL0002210',
          align: 'left',
          style: 'width:300px',
          sortable: false,
          fix: true,
        },
      ]
      let year = this.dailyCircuit.checkDate.substring(0, 4);
      let month = this.dailyCircuit.checkDate.substring(5);

      let days = [];
      this.$http.url = this.$format(this.holidayUrl, year);
      this.$http.type = 'GET';
      this.$http.request((_result) => {
        this.holidayList = _result.data

        let yearmonth = `${year}-${this.$_.padStart(month, 2, '0')}`;
        let yearmonthDays = this.$comm.moment(yearmonth).daysInMonth();

        for (let idx = 1; idx <= yearmonthDays; idx++) {
          let isHoliday = this.isHoliday(`${yearmonth}-${this.$_.padStart(idx, 2, '0')}`);
          days.push({
            name: 'day' + idx + 'Name',
            field: 'day' + idx + 'Name',
            key: 'day' + idx,
            label: idx,
            align: 'center',
            setHeader: true,
            style: 'width:35px',
            headerColor: isHoliday ? '#FFCDD2' : '',
            // tdColor: isHoliday ? '#D9D9D9' : null,
            headerType: 'link',
            sortable: false,
          })
        }
        this.grid.columns = this.$_.concat(_columns, days);
      },);

      this.dailyCircuit.checkName = year + '년  ' + month + '월 일상 순회점검'
    },
    isHoliday(day) {
      // 일 : 0
      // 토 : 6
      let dayOfWeek = this.$comm.moment(day).day();
      if ([0, 6].indexOf(dayOfWeek) > -1) {
        return true;
      } else if (this.$_.findIndex(this.holidayList, { holiday: day }) > -1) {
        return true;
      } else {
        return false;
      }
    },
    saveData() {
      if (this.isOld) {
        this.saveUrl = transactionConfig.sop.dcc.plan.update.url;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.dcc.plan.insert.url;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {            
          window.getApp.$emit('CONFIRM', {
            title: 'LBLCONFIRM',
            message: 'MSGSAVE', // 저장하시겠습니까?
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.dailyCircuit.regUserId = this.$store.getters.user.userId;
              this.dailyCircuit.chgUserId = this.$store.getters.user.userId;

              if (this.mappingType === 'POST') {
                this.$_.forEach(this.dailyCircuit.checkResultList, _item => {
                  _item.editFlag = 'C';
                })
              }

              this.isSave = !this.isSave;
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          });
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveData2() {
      if (this.isOld) {
        this.saveUrl = transactionConfig.sop.dcc.plan.update.url;
        this.mappingType = 'PUT';
      } else {
        this.saveUrl = transactionConfig.sop.dcc.plan.insert.url;
        this.mappingType = 'POST';
      }
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {            
          this.dailyCircuit.regUserId = this.$store.getters.user.userId;
          this.dailyCircuit.chgUserId = this.$store.getters.user.userId;

          if (this.mappingType === 'POST') {
            this.$_.forEach(this.dailyCircuit.checkResultList, _item => {
              _item.editFlag = 'C';
            })
          }

          this.isSave = !this.isSave;
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      });
    },
    saveCallback(result) {
      window.getApp.$emit('APP_REQUEST_SUCCESS');
      this.popupParam.dccDailyCircuitCheckId = result.data
      if (this.mappingType === 'POST') {
        this.$set(this.tabItems[1], 'disabled', false)
      }
      this.getDetail();
    },
    saveDataAppr() {
      this.$refs['editForm'].validate().then(_result => {
        if (_result) {      
          window.getApp.$emit('CONFIRM', {
            title: '확인',
            message: '결재요청 하기 전 입력된 값을 저장합니다.\n\r 진행하시겠습니까?', 
            // TODO : 필요시 추가하세요.
            type: 'info', // success / info / warning / error
            // 확인 callback 함수
            confirmCallback: () => {
              this.dailyCircuit.regUserId = this.$store.getters.user.userId;
              this.dailyCircuit.chgUserId = this.$store.getters.user.userId;

              let promises = [
                {
                  func: this.approvalValue
                },
              ];
              this.$comm.orderedPromise(promises);
            },
            // 취소 callback 함수
            cancelCallback: () => {
            },
          })
        } else {
          window.getApp.$emit('APP_VALID_ERROR');
        }
      }); 
    },
    // [S] 결재관련 
    approvalCallback() { // 결재관련 결재요청버튼 callback
      this.$refs['appr-btn'].apprRequestPop();
    },
    approvalValue() {
      return new Promise(resolve => {
        this.isApproval = !this.isApproval
        resolve(true);
      });
    },
    removeData() {
      window.getApp.$emit('CONFIRM', {
        title: 'LBLCONFIRM',
        message: 'MSGREMOVE', // 삭제하시겠습니까?,
        // TODO : 필요시 추가하세요.
        type: 'warning', // success / info / warning / error
        // 확인 callback 함수
        confirmCallback: () => {
          this.$http.url = this.$format(this.deleteUrl, this.popupParam.dccDailyCircuitCheckId);
          this.$http.type = 'DELETE';
          this.$http.request(() => {
            window.getApp.$emit('APP_REQUEST_SUCCESS');
            this.$emit('closePopup');
          },);
        },
        // 취소 callback 함수
        cancelCallback: () => {
        },
      });
    },
    /* eslint-disable no-unused-vars */
    setDeptName(deptName) {
      this.dailyCircuit.checkDeptName = deptName;
    },
    tabClick() {
       this.$set(this.research, 'impr', uid())
    },
  }
};
</script>
